import { Box } from '@mui/system';
import { Form } from 'formik';
import { useMemo } from 'react';
import { CancelButton, SaveButton } from '@shared/inputs/Buttons';
import { FormPart } from '@modules/shared/components/FormPart';
import { TextInputField } from '@shared/fields/TextInputField';
import { SelectAutocompleteField } from '@shared/fields/SelectAutocompleteField';
import { IWorkflowFormProps } from '../../types';
import { entityTypeMock } from '../../constants';

export const WorkflowForm = ({
  handleSubmit,
  handleClose,
  values,
  isEditMode,
  dirty,
}: IWorkflowFormProps) => {

  const config = useMemo(() => [
    {
      width: '100%',
      name: 'name',
      label: isEditMode ? 'Workflow Name' : 'New Workflow Name',
      value: values?.name,
      component: TextInputField,
    },
    {
      width: '100%',
      name: 'entityType',
      label: 'Entity type',
      value: values?.entityType,
      component: SelectAutocompleteField,
      disabled: isEditMode,
      options: entityTypeMock,
    },
  ], [values?.name, values?.entityType, isEditMode]);
  
  return (
    <Form onSubmit={handleSubmit}>
      <FormPart config={config} />
      <Box position="relative" display="flex" justifyContent="flex-end">
        <CancelButton onClick={handleClose} />
        <SaveButton disabled={!dirty}/>
      </Box>
    </Form>
  );
};
